var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 1133,
    viewBox: "0 0 558 1133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81323 513.613C11.1224 456.474 22.9999 398.494 39.4454 339.674C55.891 280.854 89.239 231.697 139.49 192.203C189.74 152.71 244.559 120.359 303.946 95.1501C363.333 69.9415 425.004 45.1531 488.959 20.7848C552.914 -3.5835 617.783 -6.52466 683.565 11.9617C749.348 30.448 805.08 62.3789 850.762 107.754C896.445 153.13 949.893 188.842 1011.11 214.891C1072.32 240.94 1122.57 280.013 1161.86 332.111C1201.15 384.209 1223.07 441.769 1227.64 504.79C1232.21 567.812 1229.47 630.413 1219.42 692.594C1209.37 754.775 1186.07 811.495 1149.52 862.752C1112.98 914.01 1074.15 964.427 1033.03 1014C991.92 1063.58 938.472 1096.35 872.69 1112.32C806.907 1128.28 742.495 1135.01 679.454 1132.48C616.412 1129.96 553.828 1128.28 491.7 1127.44C429.572 1126.6 365.617 1119.04 299.834 1104.75C234.052 1090.47 175.579 1062.32 124.414 1020.31C73.2502 978.292 45.3842 924.934 40.8159 860.231C36.2477 795.529 27.1112 735.869 13.4065 681.25C-0.298218 626.632 -3.49597 570.753 3.81323 513.613Z",
    fill: "url(#paint0_radial_779_657)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_779_657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(614.891 566.5) rotate(-36.8569) scale(3214.34 3108.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577365,
    stopColor: "#1A1A1A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#9700FF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#DC9D36",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#2140DE",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobRight);
export default __webpack_public_path__ + "static/media/Blob-right.2b1b0088368dcc438e4659069f40eb68.svg";
export { ForwardRef as ReactComponent };